import Vue from 'vue';
import App from './MyCampusStudMeineDatenEditAdresseApp.vue';

window.Apps = window.Apps || {};
Apps.initMyCampusStudMeineDatenEditAdresse = function (data) {
    new Vue({
        el: '#mycampus-studmeinedaten-editadresse-app',
        data: data,
        render: h => h(App)
    });
};